<template>
  <div class="slider-wrapper d-flex">
    <input
      v-if="minInputName"
      :name="minInputName"
      :value="getNumberFromString(min)"
      type="hidden"
    />
    <input :name="maxInputName" :value="getNumberFromString(max)" type="hidden" />
    <div ref="slider"></div>
    <p :style="labelStyle" class="text-small text-numbers-tabular text-right">
      {{ [min, max].filter(n => n).join(" - ") }}
    </p>
  </div>
</template>

<script>
import * as NoUISlider from "nouislider";
import "nouislider/distribute/nouislider.css";
const wNumb = require("wnumb");

export default {
  name: "RangeSlider",
  props: {
    options: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      slider: undefined,
      min: "",
      max: "",
      minInputName: this.options.minInputName,
      maxInputName: this.options.maxInputName,
    };
  },
  computed: {
    maxValue() {
      return this.options.range.max[0].toFixed(this.decimals);
    },
    labelStyle() {
      return `min-width: ${this.options.minLabelWidth}`;
    },
  },
  mounted() {
    this.slider = this.createSlider(this.$refs.slider);
    this.slider.set(this.options.start);
    this.setUpdateListener();
  },
  methods: {
    createSlider(element) {
      return NoUISlider.create(element, {
        connect: this.options.connect,
        behaviour: this.options.behaviour,
        start: this.options.start,
        range: this.options.range,
        tooltips: this.options.tooltips,
        format: wNumb({
          decimals: this.options.decimals,
          edit: value => {
            if (this.options.addSuffixToMaxValue && value === this.maxValue) {
              return [`${value}${this.options.maxValSuffix}`, this.options.suffix].join(" ");
            }
            return [value, this.options.suffix].join(" ");
          },
        }),
      });
    },
    setUpdateListener() {
      this.slider.on("update", values => {
        if (values.length === 1) {
          this.max = values[0];
        } else {
          this.min = values[0];
          this.max = values[1];
        }
        this.$emit("maxValueChanged", this.max);
      });
    },
    getNumberFromString(stringValue) {
      return stringValue.replace(/\D/g, "");
    },
  },
};
</script>

<style lang="scss">
@import "~styles/global";

.noUi-target {
  flex-grow: 1;
}

.noUi-base {
  .noUi-tooltip {
    display: none;
  }

  .noUi-active .noUi-tooltip {
    display: block;
  }

  .noUi-connect {
    background: $secondary;
  }

  .noUi-touch-area {
    cursor: grab;
  }
}
</style>
